
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/autenticacion/registro",
      function () {
        return require("private-next-pages/autenticacion/registro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/autenticacion/registro"])
      });
    }
  